"use client"

import Link from "next/link"
import { ArrowRight, Route } from "lucide-react"
import { trackEvent } from "@/lib/analytics"

interface MowingStripeStudioCtaProps {
  grassType: string
  season?: string
  mowerType: "rotary" | "reel" | "robotic"
}

export function MowingStripeStudioCta({
  grassType,
  season,
  mowerType,
}: MowingStripeStudioCtaProps) {
  const params = new URLSearchParams({
    grass: grassType,
    source: "mowing_calculator",
    mower: mowerType,
  })
  if (season) params.set("season", season)

  const href = `/games/lawn-stripe-studio?${params.toString()}`

  return (
    <aside
      className="flex flex-col gap-4 rounded-2xl border border-gray-200 bg-white p-5 shadow-elevation-2 sm:flex-row sm:items-center sm:gap-6 sm:p-6"
      data-testid="mowing-stripe-studio-cta"
      aria-labelledby="mowing-stripe-studio-title"
    >
      <span
        className="flex size-11 shrink-0 items-center justify-center rounded-xl bg-green-50 text-green-700"
        aria-hidden="true"
      >
        <Route className="size-5" />
      </span>
      <div className="min-w-0 flex-1">
        <h2
          id="mowing-stripe-studio-title"
          className="text-balance text-base font-semibold text-gray-900"
        >
          Can you stripe this {grassType} lawn?
        </h2>
        <p className="mt-1 text-sm leading-6 text-gray-600">
          Mow a tiny yard, keep the passes clean, and see how your route affects the finish.
        </p>
      </div>
      <Link
        href={href}
        onClick={() => {
          trackEvent("lawn_stripe_game_entry_clicked", {
            source: "mowing_calculator",
            grass_type: grassType,
            season,
            mower_type: mowerType,
            schema_version: 1,
          })
        }}
        className="press inline-flex min-h-11 w-full shrink-0 items-center justify-center gap-2 rounded-xl bg-action px-5 text-sm font-semibold text-action-foreground hover:bg-action-hover sm:w-auto"
      >
        Open Lawn Stripe Studio
        <ArrowRight className="size-4" aria-hidden="true" />
      </Link>
    </aside>
  )
}
